module.exports = __webpack_public_path__ + "Server-Unhealthy.TentacleActive.6bf2815dda656dec0d4aef75e6a52730.hashedasset.svg";